import React from "react";
import {
  Box,
  Typography,
  Avatar,
  Chip,
  Paper,
  Button,
  Stack,
  Grid,
  IconButton,
} from "@mui/material";
import { FaBolt, FaArrowUp, FaChevronDown, FaCheckCircle, FaFire, FaLightbulb } from "react-icons/fa";

const LeftSide = ({ selectedPicks, handleSelectOption }) => {
  const players = [
    {
      id: 1,
      name: "Paul Skenes",
      team: "SP - PIT",
      match: "HOU @ PIT Jun 4th 4:10 AM",
      avatar:
        "https://content.sportslogos.net/logos/53/70/full/pittsburgh_pirates_primary_logo_2024_sportslogosnet-9365.png",
      stat: "SO (K)",
      options: [
        { side: "Less", label: "5.5 SO (K)", value: "1.6x" },
        { side: "Less", label: "4.5 SO (K)", value: "" },
        { side: "Less", label: "6.5 SO (K)", value: "" },
        { side: "Less", label: "7.5 SO (K)", value: "" },
        { side: "More", label: "5.5 SO (K)", value: "1.62x", hot: true },
        { side: "More", label: "4.5 SO (K)", value: "1.18x" },
        { side: "More", label: "6.5 SO (K)", value: "2.1x" },
        { side: "More", label: "7.5 SO (K)", value: "2.96x" },
      ],
    },
    {
      id: 2,
      name: "Mike Trout",
      team: "CF - LAA",
      match: "LAA @ BOS Jun 4th 4:40 AM",
      avatar:
        "https://content.sportslogos.net/logos/53/72/full/los_angeles_angels_primary_logo_2023_sportslogosnet-4233.png",
      stat: "Hits",
      options: [
        { side: "Less", label: "0.5 Hits", value: "2.76x" },
        { side: "Less", label: "1.5 Hits", value: "" },
        { side: "Less", label: "2.5 Hits", value: "" },
        { side: "More", label: "0.5 Hits", value: "1.42x", hot: true },
        { side: "More", label: "1.5 Hits", value: "2.81x" },
        { side: "More", label: "2.5 Hits", value: "7.84x" },
      ],
    },
    {
      id: 3,
      name: "Shohei Ohtani",
      team: "DH - LAD",
      match: "LAD @ NYM Jun 5th 7:10 PM",
      avatar:
        "https://content.sportslogos.net/logos/53/83/full/los_angeles_dodgers_primary_logo_2023_sportslogosnet-9951.png",
      stat: "Home Runs",
      options: [
        { side: "Less", label: "0.5 HR", value: "1.90x" },
        { side: "Less", label: "1.5 HR", value: "" },
        { side: "More", label: "0.5 HR", value: "2.30x", hot: true },
        { side: "More", label: "1.5 HR", value: "4.80x" },
      ],
    },
    {
      id: 4,
      name: "Aaron Judge",
      team: "RF - NYY",
      match: "NYY @ TOR Jun 6th 1:05 PM",
      avatar:
        "https://content.sportslogos.net/logos/53/68/full/new_york_yankees_primary_logo_2020_sportslogosnet-4701.png",
      stat: "RBIs",
      options: [
        { side: "Less", label: "1.5 RBIs", value: "1.55x" },
        { side: "Less", label: "2.5 RBIs", value: "" },
        { side: "More", label: "1.5 RBIs", value: "2.10x", hot: true },
        { side: "More", label: "2.5 RBIs", value: "3.60x" },
      ],
    },
    {
      id: 5,
      name: "Freddie Freeman",
      team: "1B - LAD",
      match: "LAD @ SF Jun 7th 9:45 PM",
      avatar:
        "https://content.sportslogos.net/logos/53/83/full/los_angeles_dodgers_primary_logo_2023_sportslogosnet-9951.png",
      stat: "Hits",
      options: [
        { side: "Less", label: "1.0 Hits", value: "1.75x" },
        { side: "Less", label: "2.0 Hits", value: "" },
        { side: "More", label: "1.0 Hits", value: "2.50x", hot: true },
        { side: "More", label: "2.0 Hits", value: "3.80x" },
      ],
    },
    {
      id: 6,
      name: "Ronald Acuña Jr.",
      team: "RF - ATL",
      match: "ATL @ MIA Jun 8th 7:20 PM",
      avatar:
        "https://content.sportslogos.net/logos/53/51/full/atlanta_braves_primary_logo_2022_sportslogosnet-7653.png",
      stat: "Stolen Bases",
      options: [
        { side: "Less", label: "0.5 SB", value: "1.95x" },
        { side: "More", label: "0.5 SB", value: "2.70x", hot: true },
      ],
    }
  ];

  const isOptionSelected = (playerId, option) => {
    const pick = selectedPicks.find((p) => p.player.id === playerId);
    return (
      pick &&
      pick.option.label === option.label &&
      pick.option.side === option.side
    );
  };

  return (
    <Grid item xs={12} md={7}>
      <Stack spacing={3}>
        {players.map((player) => (
          <Paper
            key={player.id}
            elevation={1}
            sx={{
              borderRadius: "20px",
              p: 2,
              position: "relative",
              backgroundColor: "#fff",
              border: "1px solid #f0f0f0",
            }}
          >
            {/* Boost Chip */}
            <Chip
              label={
                <Typography fontWeight="bold" fontSize={14}>
                  Payout Boost Special* &nbsp; 08:07:59
                </Typography>
              }
              sx={{
                backgroundColor: "#FFD500",
                color: "black",
                px: 3,
                py: 1,
                position: "absolute",
                top: -12,
                left: 20,
                borderRadius: "999px",
              }}
            />

            {/* Lightbulb Icon */}
            <Box position="absolute" top={16} right={16} color="gray">
              <FaLightbulb size={20} />
            </Box>

            {/* Player Info */}
            <Box display="flex" alignItems="center" gap={2} mt={4} mb={3}>
              <Avatar src={player.avatar} sx={{ width: 56, height: 56 }} />
              <Box>
                <Typography fontWeight="bold" fontSize={18}>
                  {player.name}
                </Typography>
                <Typography fontSize={14} color="text.secondary">
                  {player.team}
                </Typography>
                <Typography fontSize={13} color="text.secondary">
                  {player.match}
                </Typography>
              </Box>
            </Box>

            {/* LESS - STAT - MORE */}
            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography fontWeight="bold" fontSize={13}>
                Less <FaBolt style={{ color: "gold", verticalAlign: "middle" }} />
              </Typography>
              <Typography fontWeight="bold" fontSize={13}>
                {player.stat}
              </Typography>
              <Typography fontWeight="bold" fontSize={13}>
                More <FaArrowUp style={{ color: "gold", verticalAlign: "middle" }} />
              </Typography>
            </Box>

            {/* LESS and MORE columns */}
            <Box display="flex" justifyContent="space-between">
              {/* LESS column */}
              <Stack spacing={1} flex={1}>
                {player.options
                  .filter((opt) => opt.side === "Less")
                  .map((opt, i) => (
                    <Button
                      key={i}
                      variant="outlined"
                      fullWidth
                      sx={{
                        borderRadius: "999px",
                        height: 40,
                        fontWeight: "bold",
                        fontSize: 14,
                        justifyContent: "center",
                        backgroundColor: isOptionSelected(player.id, opt)
                          ? "#FFD500"
                          : "#f9f9f9",
                        borderColor: "#e0e0e0",
                        color: "#000",
                      }}
                      onClick={() => handleSelectOption(player, opt)}
                      startIcon={
                        isOptionSelected(player.id, opt) ? (
                          <FaCheckCircle size={16} color="#00cc66" />
                        ) : null
                      }
                    >
                      {opt.value}
                    </Button>
                  ))}
              </Stack>

              {/* STAT center */}
              <Stack
                spacing={1}
                justifyContent="center"
                alignItems="center"
                flex={1}
              >
                {player.options
                  .filter((opt) => opt.side === "Less")
                  .map((opt, i) => (
                    <Typography
                      key={i}
                      fontWeight={500}
                      fontSize={14}
                      color="#000"
                    >
                      {opt.label}
                    </Typography>
                  ))}
              </Stack>

              {/* MORE column */}
              <Stack spacing={1} flex={1} alignItems="flex-end">
                {player.options
                  .filter((opt) => opt.side === "More")
                  .map((opt, i) => (
                    <Button
                      key={i}
                      variant="outlined"
                      fullWidth
                      sx={{
                        borderRadius: "999px",
                        height: 40,
                        fontWeight: "bold",
                        fontSize: 14,
                        justifyContent: "center",
                        backgroundColor: isOptionSelected(player.id, opt)
                          ? "#FFD500"
                          : "#f9f9f9",
                        borderColor: isOptionSelected(player.id, opt)
                          ? "#FFD500"
                          : "#e0e0e0",
                        color: "#000",
                        position: "relative",
                      }}
                      onClick={() => handleSelectOption(player, opt)}
                    >
                      {opt.hot && (
                        <FaFire
                          size={14}
                          color="#FF5722"
                          style={{
                            position: "absolute",
                            left: 12,
                          }}
                        />
                      )}
                      {opt.value}
                      {isOptionSelected(player.id, opt) && (
                        <FaCheckCircle
                          size={16}
                          color="#00cc66"
                          style={{ marginLeft: 8 }}
                        />
                      )}
                    </Button>
                  ))}
              </Stack>
            </Box>

            {/* Show more */}
            <Box mt={3} textAlign="center">
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#FFD500",
                  color: "black",
                  fontWeight: "bold",
                  borderRadius: 8,
                  textTransform: "none",
                  px: 4,
                  py: 1,
                }}
                startIcon={<FaChevronDown />}
              >
                Show more
              </Button>
            </Box>
          </Paper>
        ))}
      </Stack>
    </Grid>
  );
};

export default LeftSide;